import { Company, Mode, PeriodDefinition, Year } from ".";
import { ReportConfig } from "./ReportConfig";

export class CompanyReportSectionConfig {
    private _company: Company;
    private _periodDefinition: PeriodDefinition;
    private _modeList: Mode[];
    private _reportConfigList: ReportConfig[];

    constructor(
        company: Company,
        periodDefinition: PeriodDefinition,
        modeList: Mode[],
        reportConfigList: ReportConfig[]
    ) {
        this._company = company;
        this._periodDefinition = periodDefinition;
        this._modeList = modeList;
        this._reportConfigList = reportConfigList;
    }

    get company() {
        return this._company;
    }

    get periodDefinition() {
        return this._periodDefinition;
    }

    get modeList() {
        return this._modeList;
    }

    get reportConfigList() {
        return this._reportConfigList;
    }

    public isReportAvailable(names: string[]) {
        const numOfReports = this._reportConfigList
            .map((r) => r.reportCode)
            .filter((c) => names.findIndex((n) => n === c) > -1).length;
        return numOfReports > 0;
    }
}
